import React from "react";
import PropTypes from "prop-types";

/**
 * DirhamSymbol renders the AED dirham symbol using the aed-font class.
 * @param {object} props
 * @param {number} [props.fontSize=15] - Font size in pixels.
 * @returns {JSX.Element}
 */
export const DirhamSymbol = ({ fontSize = 15 }) => (
  <span className="aed-font" style={{ fontSize: `${fontSize}px` }}>
    D
  </span>
);

DirhamSymbol.propTypes = {
  fontSize: PropTypes.number
};

/**
 * Returns the HTML string for the dirham symbol, for use in dangerouslySetInnerHTML contexts.
 * @param {number} [fontSize=15] - Font size in pixels.
 * @returns {string}
 */
export const dirhamSymbolHtml = (fontSize = 15) =>
  `<span class="aed-font" style="font-size: ${fontSize}px">D</span>`;
